// 获取Defi数据———总锁仓
export const GETDEFITOTALLOCKED = 'get-defi-totalLocked'
// 获取Defi数据———总市值
export const GETDEFIMARKETCAP = 'get-defi-marketcap'
// 获取Defi数据———单项内容
export const GETDEFIITEMINFO = 'get-defi-iteminfo'
// 获取首页广告数据
export const GETADDATA = 'get-ad-data'
// 获取首页广告图片数据
export const GETADIMGDATA = 'get-ad-img-data'
// 获取首页精选内容
export const GETADRECOMMEND = 'get-ad-recommend'
// 获取首页右侧新闻排行
export const GETRANKNEWS = 'get-rank-news'
// 获取首页最新专题
export const GETSUBJECT = 'get-subject'
// 获取首页精选视频
export const GETVIDEO = 'get-video'
// 获取首页精选标签
export const GETTAGS = 'get-tags'
// 获取首页新闻导航栏
export const GETLEFTNEWSCHANNELID = 'get-left-news-channel-id'
// 获取首页新闻头条
export const GETNEWSHEADLINES = 'get-left-news-headlines'
// 获取首页更多的新闻头条
export const GETNEWSHEADLINESMORE = 'get-left-news-headlines-more'
// 获取首页全部新闻内容
export const GETNEWSTOTALLIST = 'get-left-news-total-list'
// 获取首页更多的全部新闻内容
export const GETNEWSTOTALLISTMORE = 'get-left-news-total-list-more'
// 获取首页热门作者
export const GETHOMESHOWAUTHORLIST = 'get-show-author-list'
// 获取首页当前汇率
export const GETEXCHANGERATES = 'get-exchange-rates'
// 获取首页货币行情
export const GETMARKERQUOTATIONS = 'get-marker-quotations'
// 获取首页后台可控直播入口
export const GETHOMEROOMLIST = 'get-home-room-list'
// 首页节日背景关闭
export const FESTIVALCLOSE = 'festival-close'
// 获取element banner数据
export const GETELEMNETBANNER = 'get-element-banner'
// 获取element banner详情
export const GETCOLLECTIONDEATIL = 'get-collection-detail'
